export { default as ModalOrderDetails } from './modal-order-details';
